<template>
    <div  v-if="displayed" class="main">
        <slot></slot>
    </div>
</template>

<script>

export default {
    props: {
        name: {
            type: String,
            required: true
        },
    },
    data () {
        return {
            displayed: false,
        };
    },
    computed: {
    },
    methods: {
        show(){
            this.displayed = true;
        },
        hide(){
            this.displayed = false;
        },
    }
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/partials/wizzard/Step.vue